import type { SVGProps } from "react"
const Stack = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      d="M4.94845 4.68299C5.32822 4.24896 5.87687 4 6.4536 4H17.5461C18.1228 4 18.6714 4.24896 19.0512 4.68299L22.5512 8.68299C23.6827 9.97616 22.7644 12 21.0461 12H2.9536C1.23528 12 0.316926 9.97616 1.44845 8.68299L4.94845 4.68299ZM17.5461 6L6.4536 6L2.9536 10H21.0461L17.5461 6ZM1.99983 15C1.99983 14.4477 2.44755 14 2.99983 14H20.9998C21.5521 14 21.9998 14.4477 21.9998 15C21.9998 15.5523 21.5521 16 20.9998 16H2.99983C2.44755 16 1.99983 15.5523 1.99983 15ZM2.99983 19C2.99983 18.4477 3.44755 18 3.99983 18H19.9998C20.5521 18 20.9998 18.4477 20.9998 19C20.9998 19.5523 20.5521 20 19.9998 20H3.99983C3.44755 20 2.99983 19.5523 2.99983 19Z"
      fill="currentColor"
    />
  </svg>
)
export default Stack
